module.exports = __webpack_public_path__ + "img/calm-sprite.b2178ff7.svg";